export default function formatCurrency(value: number, keepNegative?: boolean): string {
  const formatNumber = keepNegative ? value : Math.abs(value)
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })

  const formattedValue = formatter.format(formatNumber)?.replace(/Rp\s*/g, '')

  return formattedValue
}
